import { z } from "zod"

export const DartyOctopusAuthResponseSchema = z
    .object({
        name: z.string(),
        email: z.string(),
        oeBackendToken: z.string(),
    })
    .transform(({ name, oeBackendToken }) => ({
        accessToken: oeBackendToken,
        user: {
            fullname: name,
        },
    }))
